export type View = 'dashboard' | 'mypage' | 'workflow' | 'org_mgmt' | 'recruitment' | 'eval_mgmt' | 'talent_dev' | 'promotion' | 'compensation' | 'compliance' | 'talent_pool' | 'hr_analytics' | 'system_settings' | 'upload' | 'organization' | 'overtime' | 'attendance' | 'leave' | 'notice_board' | 'weekly_report';

/** View ID → URL path mapping (kebab-case, plural nouns for collections) */
export const VIEW_TO_PATH: Record<View, string> = {
  dashboard: '/dashboard',
  mypage: '/mypage',
  workflow: '/workflow',
  org_mgmt: '/organization',
  recruitment: '/recruitment',
  eval_mgmt: '/evaluations',
  talent_dev: '/talent-development',
  promotion: '/promotions',
  compensation: '/compensation',
  compliance: '/compliance',
  talent_pool: '/talent-pool',
  hr_analytics: '/analytics',
  system_settings: '/settings',
  upload: '/upload',
  organization: '/org-chart',
  overtime: '/overtime',
  attendance: '/attendance',
  leave: '/leave',
  notice_board: '/notices',
  weekly_report: '/weekly-reports',
};

/** URL path → View ID reverse mapping */
export const PATH_TO_VIEW: Record<string, View> = Object.fromEntries(
  Object.entries(VIEW_TO_PATH).map(([view, path]) => [path, view as View])
) as Record<string, View>;

/** Role-based menu access control */
export const MENU_ROLES: Record<View, string[]> = {
  dashboard: ['admin', 'hr_manager'],
  mypage: ['admin', 'hr_manager', 'org_head', 'employee'],
  workflow: ['admin', 'hr_manager', 'org_head', 'employee'],
  org_mgmt: ['admin', 'hr_manager', 'org_head'],
  recruitment: ['admin', 'hr_manager'],
  eval_mgmt: ['admin', 'hr_manager', 'org_head', 'employee'],
  talent_dev: ['admin', 'hr_manager', 'org_head'],
  promotion: ['admin', 'hr_manager'],
  compensation: ['admin', 'hr_manager'],
  compliance: ['admin', 'hr_manager', 'org_head', 'employee'],
  talent_pool: ['admin', 'hr_manager'],
  hr_analytics: ['admin', 'hr_manager', 'org_head'],
  system_settings: ['admin'],
  upload: ['admin', 'hr_manager'],
  organization: ['admin', 'hr_manager'],
  overtime: ['admin', 'hr_manager', 'org_head', 'employee'],
  attendance: ['admin', 'hr_manager', 'org_head', 'employee'],
  leave: ['admin', 'hr_manager', 'org_head', 'employee'],
  notice_board: ['admin', 'hr_manager', 'org_head', 'employee'],
  weekly_report: ['admin', 'hr_manager', 'org_head', 'employee'],
};

/** View display titles */
export const VIEW_TITLES: Record<View, string> = {
  dashboard: '대시보드',
  mypage: '마이페이지',
  workflow: '결재함',
  org_mgmt: '조직 관리',
  recruitment: '채용 관리',
  eval_mgmt: '평가 관리',
  talent_dev: '역량 육성',
  promotion: '승진 관리',
  compensation: '보상 관리',
  compliance: '컴플라이언스',
  talent_pool: '인재 관리',
  hr_analytics: '인사 분석',
  system_settings: '시스템 설정',
  upload: '직원 등록',
  organization: '조직도',
  overtime: '초과근무 관리',
  attendance: '근무 관리',
  leave: '연차/휴가',
  notice_board: '공지 / 게시판',
  weekly_report: '주간 보고',
};
